/**
 * Textarea configuration constants
 */
export const textareaConfig = {
  /** Row size for inline text elements */
  inlineTextRowSize: 5,
  /** Default row size for textarea */
  defaultRowSize: 1
};
